import { IOfficialDailyDetailResponse } from "../../../model/base/response/official-daily-detail-response";

export type OfficialDailyDetailState = {
  detail: IOfficialDailyDetailResponse | null;
  loading: boolean;
  error: string | null;
};

export enum ACTION_TYPES {
  loadingDetail = 'loadingDetail',
  setLoading = 'setLoading',
  setError = 'setError',
  clearData = 'clearData'
}

export type OfficialDailyDetailAction = {
  type: ACTION_TYPES;
  payload?: any;
};

export const initialState: OfficialDailyDetailState = {
  detail: null,
  loading: true,
  error: null,
};

export const OfficialDailyDetailReducer = (
  state: OfficialDailyDetailState,
  action: OfficialDailyDetailAction
): OfficialDailyDetailState => {
  switch (action.type) {
    case ACTION_TYPES.loadingDetail:
      return {
        ...state,
        detail: action.payload,
        loading: false,
        error: null,
      };
    case ACTION_TYPES.setLoading:
      return {
        ...state,
        loading: action.payload,
      };
    case ACTION_TYPES.setError:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case ACTION_TYPES.clearData:
      return initialState;
    default:
      return state;
  }
};
